import { render, staticRenderFns } from "./round-button.vue?vue&type=template&id=5bb7af0a&scoped=true&"
import script from "./round-button.js?vue&type=script&lang=js&"
export * from "./round-button.js?vue&type=script&lang=js&"
import style0 from "./round-button.scss?vue&type=style&index=0&id=5bb7af0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb7af0a",
  null
  
)

export default component.exports